import { stringify } from '../../utils/object/stringify'
import { getSyslogSeverityFromPinoLevel } from './getSyslogSeverityFromPinoLevel'
import { SyslogFacility } from './SyslogFacility'
import type { VtexLog } from '../VtexLog'

export type SyslogOptions = {
  appName?: string
  facility?: SyslogFacility
}

/**
 * @description https://datatracker.ietf.org/doc/html/rfc5424
 */
export const Syslog = {
  create({
    facility = SyslogFacility.Local0,
    appName = '-',
  }: SyslogOptions = {}) {
    const format = ({ timestamp, ...log }: VtexLog) => {
      const severity = getSyslogSeverityFromPinoLevel(log.level)
      const priority = 8 * facility + severity
      const version = 1
      const { hostname = '-', pid = '-' } = log.extra_fields ?? {}
      // TODO: should we support user-defined timezones?
      const msgId = '-'
      const structuredData = '-'
      const header = `<${priority}>${version} ${timestamp} ${hostname} ${appName} ${pid} ${msgId} ${structuredData} `
      const message = stringify(log)

      return `${header}${message}`
    }

    return { format }
  },
}
